import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqAuthorFormat',
    standalone: false
})
export class AuthorFormatPipe implements PipeTransform {
  public transform (text: string) {
    const authors = text.split('||||||');

    if (authors.length === 1) {
      text = authors[0];
    } else if (authors.length === 2) {
      text = authors[0] + ' and ' + authors[1];
    } else if (authors.length > 2) {
      text = authors[0] + ' et al';
    }

    return text + '. ' || '';
  }
}
